// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { styledBoxStyle } from "@sc/XDL/Components/Common/Box";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { avoidBreakInsidePrintElement, color, mergeWithCss } from "@sc/XDL/Utilities";
import { css } from "styled-components";

interface OrderTotalDisplaySharedStyles {
    mainContainer: GridContainerProps;
    label: TypographyPresentationProps;
    value: TypographyPresentationProps;
    labelGridItem: GridItemProps;
    valueGridItem: GridItemProps;
    totalLabel?: TypographyPresentationProps;
    totalValue?: TypographyPresentationProps;
    titleText?: TypographyPresentationProps;
    styledHr?: InjectableCss;
    wrapper?: InjectableCss;
}

const label: TypographyPresentationProps = {
    size: 14,
    weight: fontConfig.weight.regular,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-bottom: 4px;
    `,
};
const value: TypographyPresentationProps = {
    size: 14,
    weight: fontConfig.weight.bold,
    css: css`
        letter-spacing: 0;
        line-height: 22px;
        margin-left: auto;
        margin-bottom: 4px;
    `,
};
export const orderTotalDisplaySharedStyles: OrderTotalDisplaySharedStyles = {
    mainContainer: {
        gap: 0,
        offsetCss: css`
            row-gap: 6px;
        `,
    },
    titleText: {
        size: 16,
        lineHeight: "22px",
        weight: fontConfig.weight.bold,
    },
    labelGridItem: {
        width: 7,
        css: css`
            padding: 0 5px;
        `,
    },
    valueGridItem: {
        css: css`
            padding: 0 5px;
            @media print {
                text-align: right;
            }
        `,
        width: 5,
    },
    label: {
        ...label,
    },
    value: {
        ...value,
    },
    totalLabel: {
        ...mergeWithCss(label, {
            size: 16,
            weight: fontConfig.weight.regular,
            css: css`
                line-height: 26px;
            `,
        }),
    },
    totalValue: {
        ...mergeWithCss(value, {
            size: 16,
            weight: fontConfig.weight.bold,
            css: css`
                line-height: 26px;
            `,
        }),
    },
    styledHr: {
        css: css`
            width: 100%;
            border: none;
            border-bottom: 1px solid ${color("common.border")};
            margin: 4px 0;
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            ${styledBoxStyle}
            ${avoidBreakInsidePrintElement}
        `,
    },
};
